import { render, staticRenderFns } from "./OtherServicesTabView.vue?vue&type=template&id=dcd90eca&"
import script from "./OtherServicesTabView.vue?vue&type=script&lang=js&"
export * from "./OtherServicesTabView.vue?vue&type=script&lang=js&"
import style0 from "./OtherServicesTabView.vue?vue&type=style&index=0&id=dcd90eca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports